import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CustomOnetrustCookieConfComponent } from './custom-onetrust-cookie-conf.component';
import { RouterModule } from '@angular/router';
import {CmsConfig, ConfigModule, I18nModule} from '@spartacus/core';

@NgModule({
  declarations: [CustomOnetrustCookieConfComponent],
  imports: [
    CommonModule,
    RouterModule,
    I18nModule,
    ConfigModule.withConfig({
      cmsComponents: {
        OnetrustCookieConfComponent: {
          component: CustomOnetrustCookieConfComponent,
        },
      },
    } as CmsConfig),
  ],
})
export class CustomOnetrustCookieConfModule {}
